import 'css-chunk-1JavaScriptSource/components/_PanelDesigner/pdTagEditor.module.scss';export default {
  "pdTagEditor": "_pdTagEditor_1ey52_1",
  "selectedPartDropdown": "_selectedPartDropdown_1ey52_10",
  "selectedPartComponentLabel": "_selectedPartComponentLabel_1ey52_10",
  "insertTagWrapper": "_insertTagWrapper_1ey52_19",
  "insertTagDescription": "_insertTagDescription_1ey52_28",
  "insertTagArgs": "_insertTagArgs_1ey52_33",
  "taggingAlert": "_taggingAlert_1ey52_40",
  "utilityButtons": "_utilityButtons_1ey52_44"
};